module.exports = __webpack_public_path__ + "177cc92d2e8027712a8c1724abd272cd.ttf";